export const getTeamId = (team: any): string =>
  team?.team?._id || "—";
